import * as yup from 'yup';

import { i18n } from '~/plugins/vue-i18n/vue-i18n.plugin';

export function setupYup() {
	const { t } = i18n.global;

	yup.setLocale({
		mixed: {
			required: () => t('commons.rules.required')
		},
		string: {
			email: () => t('commons.rules.email'),
			min: ({ min }) => t('commons.rules.min', { length: min }),
			max: ({ max }) => t('commons.rules.max', { length: max })
		},
		number: {
			min: ({ min }) => t('commons.rules.min-number', { value: min }),
			max: ({ max }) => t('commons.rules.max-number', { value: max }),
			integer: () => t('commons.rules.integer')
		},
		array: {
			min: ({ min }) => t('commons.rules.min-items', { count: min }),
			max: ({ max }) => t('commons.rules.max-items', { count: max })
		}
	});

	yup.addMethod(yup.string, 'validEmail', function () {
		return this.matches(/^[^\s@]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
			message: t('commons.rules.email'),
			excludeEmptyString: true
		});
	});
}
